var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayHamburgerMenuPremium = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0V0z",
    id: "f0zwzvztqa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#f0zwzvztqa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 1.911)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#72BBCC",
    cx: 10.455,
    cy: 10.544,
    rx: 10.455,
    ry: 10.544
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#007487",
    cx: 10.452,
    cy: 10.584,
    rx: 8.644,
    ry: 8.718
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.986 6.947)",
    fill: "#72BBCC"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.167,
    height: 1.876,
    rx: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.592,
    y: 2.751,
    width: 8.167,
    height: 1.876,
    rx: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.023,
    y: 5.596,
    width: 8.167,
    height: 1.876,
    rx: 0.92
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m20.741 1.34.79 2.546c.062.202.242.34.445.34h2.554c.454 0 .643.608.276.888l-2.067 1.574a.505.505 0 0 0-.17.549l.79 2.546c.14.453-.354.83-.722.55l-2.066-1.574a.451.451 0 0 0-.551 0l-2.066 1.574c-.368.28-.862-.097-.722-.55l.79-2.546a.505.505 0 0 0-.17-.55l-2.067-1.573c-.367-.28-.178-.889.275-.889h2.555a.471.471 0 0 0 .446-.34l.789-2.546a.462.462 0 0 1 .891 0z",
    fill: "#F1BC66"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayHamburgerMenuPremium);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-hamburger-menu-premium.3ae69022ef332f18829b2a107b3cd244.svg";